module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/social/vimeo-dd09c09b67c39433080fc27711ef6227.svg";